import Accordion from "@/common/components/Accordion"
import { CompanyData } from "@/features/companies/types/companies.type"
import { BadgeInfoIcon, CircleChevronDownIcon } from "lucide-react"
import { strategy as usageDeclarationModesStrategy } from '@/features/privateCompanies/constants/usageDeclarationModes.constant'
import { strategy as createUsageDeclarationModesStrategy } from '@/features/privateCompanies/constants/createUsageDeclarationMode.constant'
import { UpdateUsageDeclarationModeModal } from "../../../Update/components/UpdateUsageDeclarationModeModal"
import { Tooltip } from "react-tooltip"

export const UsageDeclarationModeSection = ({ company }: { company: CompanyData | undefined }) => {
  return (
    <Accordion
      defaultOpen
      head={(
        <div className="flex items-center gap-x-3">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateUsageDeclarationModeModal company={company} />
          </div>

          <p className='text-xl'>
            Declaração de uso
          </p>
        </div>
      )}
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={
        <div className='flex flex-col gap-4'>
          <div className="flex items-center gap-x-2 text-white">
            <p>Validar declaração:</p>
            <BadgeInfoIcon
              strokeWidth={1.5}
              color="var(--warning)"
              className="size-5"
              data-tooltip-id='usage_declaration_mode_value_tooltip'
              data-tooltip-place="top-start"
            />

            <Tooltip
              id='usage_declaration_mode_value_tooltip'
              className="max-w-[234px] opacity-100 backdrop-blur-3xl"
            >
              Define se a quilometragem ou hora-uso informada no equipamento deve ser validada durante a realização do consumo
            </Tooltip>

            <div className='flex items-center gap-1 text-white-400'>
              <CircleChevronDownIcon strokeWidth={1.5} />
              <p data-testid="usage_declaration_mode_value">
                {usageDeclarationModesStrategy[company?.usage_declaration_mode as keyof typeof usageDeclarationModesStrategy]}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-x-2 text-white">
            <p>Modo de alteração de quilometragem:</p>

            <div className='flex items-center gap-1 text-white-400'>
              <CircleChevronDownIcon strokeWidth={1.5} />
              <p data-testid="create_usage_declaration_mode_value">
                {createUsageDeclarationModesStrategy[company?.create_usage_declaration_mode as keyof typeof usageDeclarationModesStrategy]}
              </p>
            </div>
          </div>
        </div>
      }
    />
  )
}

export default UsageDeclarationModeSection
